import { config } from "@coffee/config";
import { MockApi } from "@unlikelyai-magic/shared/mocking";

const mockApi = new MockApi(config.API_BASE_URL);

// Add APIs to mock here e.g. mockApi.post("/xyz", async () => {...});

export { mockApi };
